// removed by extract-text-webpack-plugin
module.exports = {"stats-wrapper":"stats-wrapper___3lPDo center___2iqBf","stats":"stats___k_7jk padding-bottom-5___2nauS center___2iqBf","stat":"stat___Wl6tX","stat-count-wrapper":"stat-count-wrapper___2SBNN center___2iqBf","stat-count":"stat-count___DV4FS center___2iqBf","stat-label":"stat-label___1BNK4 h4___kHWTn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FlaggedFund/FlaggedFund.css
// module id = 888
// module chunks = 0